<script>
  export default {
    name: 'ModalMail',
    data () {
      return {
        email :"",
        name: "",
        firstname: "",
        message: "",
        interesse_par:"",
        optin: false
      }
    },
    methods: {
      close() {
        this.message = "";
        if(this.isEmailValid() != true) this.message += "Merci de renseigner un email valide"
        if(this.name == "" || this.firstname == "" ) this.message += (this.message.length > 0) ? "<br/>Merci de renseigner votre nom et prénom" : "Merci de renseigner un email valide"
        if(this.interesse_par == "")this.message += (this.message.length > 0) ? "<br/>Merci d'indiquer le système de pose qui vous intéresse" : "Merci d'indiquer le système de pose qui vous intéresse"
        if (!this.optin)this.message += (this.message ? "<br/>" : "") + "Merci d'accepter les conditions";

        if(this.isEmailValid() == true && this.name != "" && this.firstname != "" && this.interesse_par != "" && this.optin) this.$emit('close',{email:this.email,name:this.name,firstname:this.firstname,interesse_par:this.interesse_par});

      },
      closeWithoutData() {
        this.$emit('close');
      },
      isEmailValid: function() {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if(this.email.match(validRegex))return true;
        else return false;
      }
    },
  };
</script>

<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header"
          id="modalTitle"
        >

          <button
            type="button"
            class="btn-close"
            @click="closeWithoutData"
            aria-label="Close modal"
            style="border-radius:0px !important"
          >
            x
          </button>
        </header>

        <section
          class="modal-body"
          id="modalDescription"
        >
          Entrez votre nom et votre email pour recevoir votre étude par mail<br/>
          <input type="text" style="width:45%;margin-right:5%;"  placeholder="Votre nom" v-model="name">
          <input type="text" style="width:45%;margin-left:5%;" placeholder="Votre prénom" v-model="firstname">
          <input type="email"  style="width:45%;margin-right:5%;"  placeholder="Votre adresse email" v-model="email">
          <select class=""  style="width:45%;margin-left:5%;" placeholder="Système de pose" name="" v-model="interesse_par">
            <option value="F">Pose au sol sur support</option>
            <option value="T">Pose en toiture soi-même</option>
            <option value="C">Pose par un installateur RGE</option>
            <option value="Autres">Autres</option>

          </select>
          <div>
            <label>
              <input type="checkbox" v-model="optin">
              En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées par la société Sunethic. *
            </label>
          </div>

          <!--
En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées par la société. *
          -->
          <div class="errorMessage" id="" v-if="message != ''" v-html="message">

          </div>
        </section>

        <footer class="modal-footer">

          <button
            type="button"
            class="btn"
            @click="close"
            aria-label="Close modal"
          >
            Recevoir mon étude par mail
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:600;
  }

  .modal {
    background: #FFFFFF;
    overflow-x: auto;
    display: flex;
    min-width: 50%;
    flex-direction: column;
    border: 5px solid #008a83;

  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    color: #008a83;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    position: relative;
    padding: 50px 40px;
  }
.modal-body input{
  margin-top:10px;
  margin-bottom:10px;
}
  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #FFF;
    background: #008a83;;
    border-radius: 0px 0px 0px 5px;
  }
  .btn-close:hover {
    color: #FFF;
    background: #008a83;;
  }


  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }

  .errorMessage{
    padding:20px;
    margin-top:20px;
    background:#e67878;
    color:#fff;
  }
</style>
